<template>
    <div class="rankList mt10">
        <h3 class="columnTit"><span>市场交易排行榜</span><a href="https://amma.artron.net/auctionrank.php" target="_blank">查看更多</a></h3>
        <el-tabs value="first">
            <!--当代国画，近现代国画，古代国画-->
            <el-tab-pane label="油画" name="first" v-if="youhua">
                <div class="fix">
                    <ul class="fix rankTit">
                        <li class="number">排名</li>
                        <li class="artist">艺术家</li>
                        <li class="unit">RMB/平尺</li>
                        <li class="chain">涨跌幅</li>
                    </ul>
                    <ul class="fix listBox" v-for="(item,i) in youhua" :key="i">
                        <li class="number"><span>{{i+1}}</span></li>
                        <li class="artist"><a :href="'https://amma.artron.net/artronpersonal.php?artist='+encodeURIComponent(item.artnm)" target="_blank">{{item.artnm}}</a></li>
                        <li class="unit">{{item.dqjdvalu}}</li>
                        <li class="chain"><span v-if="item.dqjdjjbl > 0" class="fontRed">{{item.dqjdjjbl}}</span><span v-else-if="item.dqjdjjbl == 0">--</span><span v-else class="fontGreen">{{item.dqjdjjbl}}</span> <img src="../../assets/imgs/icon_form_up@2x.png" v-if="item.dqjdjjbl >0"><img src="../../assets/imgs/icon_form_down@2x.png" v-else-if="item.dqjdjjbl <0"></li>
                    </ul>
                </div>
            </el-tab-pane>
            <el-tab-pane label="当代国画" name="second" v-if="dangdaiguohua">
                <div class="fix">
                    <ul class="fix rankTit">
                        <li class="number">排名</li>
                        <li class="artist">艺术家</li>
                        <li class="unit">RMB/平尺</li>
                        <li class="chain">涨跌幅</li>
                    </ul>
                    <ul class="fix listBox" v-for="(item,i) in dangdaiguohua" :key="i">
                        <li class="number"><span>{{i+1}}</span></li>
                        <li class="artist"><a :href="'https://amma.artron.net/artronpersonal.php?artist='+encodeURIComponent(item.artnm)" target="_blank">{{item.artnm}}</a></li>
                        <li class="unit">{{item.dqjdvalu}}</li>
                        <li class="chain"><span v-if="item.dqjdjjbl > 0" class="fontRed">{{item.dqjdjjbl}}</span><span v-else-if="item.dqjdjjbl == 0">--</span><span v-else class="fontGreen">{{item.dqjdjjbl}}</span> <img src="../../assets/imgs/icon_form_up@2x.png" v-if="item.dqjdjjbl >0"><img src="../../assets/imgs/icon_form_down@2x.png" v-else-if="item.dqjdjjbl <0"></li>
                    </ul>
                </div>
            </el-tab-pane>
            <el-tab-pane label="近现代国画" name="third" v-if="jinxiandaiguohua">
                <div class="fix">
                    <ul class="fix rankTit">
                        <li class="number">排名</li>
                        <li class="artist">艺术家</li>
                        <li class="unit">RMB/平尺</li>
                        <li class="chain">涨跌幅</li>
                    </ul>
                    <ul class="fix listBox" v-for="(item,i) in jinxiandaiguohua" :key="i">
                        <li class="number"><span>{{i+1}}</span></li>
                        <li class="artist"><a :href="'https://amma.artron.net/artronpersonal.php?artist='+encodeURIComponent(item.artnm)" target="_blank">{{item.artnm}}</a></li>
                        <li class="unit">{{item.dqjdvalu}}</li>
                        <li class="chain"><span v-if="item.dqjdjjbl > 0" class="fontRed">{{item.dqjdjjbl}}</span><span v-else-if="item.dqjdjjbl == 0">--</span><span v-else class="fontGreen">{{item.dqjdjjbl}}</span> <img src="../../assets/imgs/icon_form_up@2x.png" v-if="item.dqjdjjbl >0"><img src="../../assets/imgs/icon_form_down@2x.png" v-else-if="item.dqjdjjbl <0"></li>
                    </ul>
                </div>
            </el-tab-pane>
            <el-tab-pane label="古代国画" name="four" v-if="gudaiguohua">
                <div class="fix">
                    <ul class="fix rankTit">
                        <li class="number">排名</li>
                        <li class="artist">艺术家</li>
                        <li class="unit">RMB/平尺</li>
                        <li class="chain">涨跌幅</li>
                    </ul>
                    <ul class="fix listBox" v-for="(item,i) in gudaiguohua" :key="i">
                        <li class="number"><span>{{i+1}}</span></li>
                        <li class="artist"><a :href="'https://amma.artron.net/artronpersonal.php?artist='+encodeURIComponent(item.artnm)" target="_blank">{{item.artnm}}</a></li>
                        <li class="unit">{{item.dqjdvalu}}</li>
                        <li class="chain"><span v-if="item.dqjdjjbl > 0" class="fontRed">{{item.dqjdjjbl}}</span><span v-else-if="item.dqjdjjbl == 0">--</span><span v-else class="fontGreen">{{item.dqjdjjbl}}</span> <img src="../../assets/imgs/icon_form_up@2x.png" v-if="item.dqjdjjbl >0"><img src="../../assets/imgs/icon_form_down@2x.png" v-else-if="item.dqjdjjbl <0"></li>
                    </ul>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    props:['youhua','dangdaiguohua','jinxiandaiguohua','gudaiguohua'],
    name: "IndexDealRank"
}
</script>

<style scoped lang="scss">
/*交易排行榜*/
.rankList{color:#262626;
    /deep/.el-tabs__item{padding:0 15px;}
    /deep/.el-tabs__active-bar{background-color: #329d15;}
    /deep/.el-tabs__item.is-active{color:#329d15}
    /deep/.el-tabs__item:hover{color:#329d15}
    /deep/.el-tabs__nav-wrap::after{display:none;}
    ul{display:flex;justify-content: space-between;align-items: center;
        .number{width:64px;
            span{width:24px;height:24px;line-height: 24px;text-align: center;color:#fff;font-weight: bold;display:inline-block;border-radius: 4px;background-color: #BFBFBF;}
        }
        .artist{width:98px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-right: 10px;}
        .unit{width:106px;}
        .chain{text-align: right;width:92px;
            .fontRed{color:#F5222D;}
            .fontGreen{color:#329D15;}
            img{width:12px;}
        }
    }
    .listBox{line-height: 50px;border-bottom: 1px solid #F2F2F2;}
    .listBox:nth-child(2){
        .number span{background-color: #F05008;}
    }
    .listBox:nth-child(3){
        .number span{background-color: #F27D00;}
    }
    .listBox:nth-child(4){
        .number span{background-color: #F2A207;}
    }
    .rankTit{padding-bottom: 13px;border-bottom: 1px solid #F2F2F2;font-weight: bold;}
}
</style>